import React from 'react';
import classNames from 'classnames';
import { MenuItem as AriaMenuItem } from 'react-aria-components';

import * as styles from './Menu.module.scss';
import { Link } from 'components/core';
import { LinkProps } from 'components/core/Link/Link.d';

export const MenuLink = ({ children, className, ...rest }: LinkProps) => {
  return (
    <Link
      className={classNames(styles.MenuItem, className)}
      component={AriaMenuItem}
      {...rest}
    >
      {children}
    </Link>
  );
};
